import { Component, OnDestroy, OnInit, forwardRef, DoCheck, Input} from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
@Component({
  selector: 'deceased-identification-pre-stage',
  templateUrl: './deceased-identification-pre-stage.component.html',

  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class DeceasedIdentificationPreStageComponent implements OnInit, OnDestroy {


  @Input() model: models.DeceasedIdentificationVM;
  @Input() isAtendimento: boolean;

  ngOnInit(): void {
  }


  ngOnDestroy(): void {
  }

  //public onNifChanges() {
  //  this.nifChanged.emit(this.nif);
  //}

  

}
